// extracted by mini-css-extract-plugin
module.exports = {"tag-element":"storyTag-m__tag-element__39dwX","story-tag":"storyTag-m__story-tag__uEX9i"};